/**
 * The organizer's logo. Loads the CDN-edge copy first and falls back to the
 * stored URL once if that fails (local dev, or a distribution not yet
 * serving /org-media/*). Renders nothing when there's no logo or neither
 * loads, so callers can lay out name-only.
 */
import { useEffect, useState } from 'react';
import type { BrandingResponse } from '@/api/embed';

export function OrgLogo({ branding, className }: { branding: BrandingResponse | null; className?: string }) {
  const primary = branding?.organizer_logo_url ?? null;
  const fallback = branding?.organizer_logo_fallback_url ?? null;
  const [src, setSrc] = useState<string | null>(primary);
  useEffect(() => setSrc(primary), [primary]);
  if (!src) return null;
  return (
    <img
      className={className}
      src={src}
      alt=""
      decoding="async"
      onError={() => setSrc(src !== fallback && fallback ? fallback : null)}
    />
  );
}
